import { ActionRow, ADMIN_TAG, SettingsCard, Tag, ToggleRow } from '../SettingsKit'

export default function AutoModerationTab() {
    return (
        <>
            <SettingsCard
                title="Auto-moderation"
                description="Choose how Arwen auto-moderates Severe comments that breach your policy. Availability depends on the platform."
            >
                <ToggleRow
                    label="Auto-hide"
                    badges={<Tag label="Most popular" />}
                    description="Hides severe comments from public view. The commenter isn't notified and it's reversible."
                    defaultOn
                />
                <ToggleRow
                    label="Auto-delete"
                    description="Permanently deletes severe comments. On some platforms the commenter is notified. Can't be reversed."
                />
                <ToggleRow
                    label="Auto-mute accounts producing severe comments"
                    badges={
                        <>
                            {ADMIN_TAG}
                            <Tag label="X only" />
                        </>
                    }
                    description="Mutes accounts whose comments are classified Severe."
                />
                <ToggleRow
                    label="Auto-hide ad comments"
                    badges={ADMIN_TAG}
                    description="Blanket-hide every comment on ads for this profile."
                />
            </SettingsCard>

            <SettingsCard
                title="Shadow banning"
                description="Automatically moderate all comments from a commenter once they cross a repeat-offender threshold. Auto-hiding must be enabled. Takes 5–10 minutes to activate."
            >
                <ActionRow
                    label="Status"
                    description="Currently off · triggers after 3 severe comments within 7 days."
                    action="Configure"
                />
            </SettingsCard>
        </>
    )
}
